import type { FeatureGroup } from '../../../../types';
import { DEVELOPMENT_FEATURE_GROUP } from '../group';

export const DEVELOPMENT_SETTINGS_FEATURE_GROUP: FeatureGroup = {
  guid: 'c5cb33bf-2aa2-4c64-95da-9e569fcdff00',
  name: 'development:settings',
  description: 'Development tools settings — configure shared options across the development apps',
  product: 'app',
  parentGuid: DEVELOPMENT_FEATURE_GROUP.guid,
};
